import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";

/**
 * Who may build Journeys, decided by the server
 * (get_my_journey_authoring_access). Journey authoring is held back for a
 * possible future plan (Oct 2026), so the server answers true for admins
 * only. Kept apart from useCreatorAccess (PowerPrompt authoring, Premium).
 */
export function useJourneyAuthoringAccess() {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ["journey-authoring-access", user?.id],
    enabled: !!user,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_my_journey_authoring_access");
      if (error) throw error;
      const result = data as { can_create_journey?: boolean; is_admin?: boolean } | null;
      return {
        canCreateJourney: result?.can_create_journey === true,
        isAdmin: result?.is_admin === true,
      };
    },
  });
  return {
    ...query,
    canAuthor: query.data?.canCreateJourney === true || query.data?.isAdmin === true,
  };
}
